import React from 'react';
import { Controller } from 'react-hook-form';
import { Input } from '..';


const SortCodeInput = ({ name, control, displayName, required, errors }) => {
  return <Controller
    name={name}
    control={control}
    rules={{
      required: required ? `${displayName} is required` : null,
      pattern: {
        value: /^[0-9]{6}$/,
        message: "Invalid UK sort code. it must be 6 digits",
      },
    }}
    render={({ field: { onChange, ...field } }) => (
      <Input
        {...field}
        className="fs-7-tight py-2"
        placeholder={"01 - 02 - 03"}
        invalid={!!errors}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, '');
          onChange(value);
        }}
      />
    )}
  />
}

export default SortCodeInput;


